import { Box, Flex, TextV2 as Text, Colors, Tag } from '@pinchenterprisesnpm/friday-ui'
import { useHistory, useLocation } from 'react-router'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormikProps, connect } from 'formik'
import { useSelector } from 'react-redux'
import { faCheck, faPen } from '@fortawesome/pro-light-svg-icons'
import { IRoster } from 'models/Roster'
import { STEP_INDEX } from '@src/features/shift-post-v2/state/shift-post-v2.types'
import { selectSelectedShift } from '@src/data/SelectedShift/selectors'
import ROUTES from '@src/routing/adminRoutes'
import { SectionContainer } from '../new-edit-modal.style'
import { INewEditModalFormValues } from '../new-edit-modal.form'
import { navigateToEditShift } from '../navigation.utils'
interface IAcceptanceCriteriaSectionProps {
  formik?: FormikProps<INewEditModalFormValues>
}

export const AcceptanceCriteriaSection = connect<IAcceptanceCriteriaSectionProps>(({ formik }) => {
  const { values } = formik
  const history = useHistory()
  const location = useLocation()
  const isBusinessShifts = location.pathname.includes(ROUTES.BUSINESSES_LIST)
  const shift = useSelector(selectSelectedShift)
  const AutoAcceptByRoster = values.auto_accept_by_rosters && values.auto_accept
  const AutoAccept = values.auto_accept

  const handleNavigateToEditShift = () => {
    navigateToEditShift(values, shift, history, STEP_INDEX.ACCEPTANCE_CRITERIA, isBusinessShifts)
  }

  if (AutoAcceptByRoster) {
    return (
      <SectionContainer>
        <Flex mb='sm' justifyContent='space-between'>
          <Text variant='h6'>Acceptance Criteria</Text>

          <FontAwesomeIcon
            icon={faPen}
            size='lg'
            style={{
              marginLeft: '8px',
              cursor: 'pointer',
              color: Colors.primary_500,
            }}
            onClick={handleNavigateToEditShift}
          />
        </Flex>
        <Box mb='sm'>
          <Text>
            Verified Upshifters from your Rosters <Tag type='plum'>NEW</Tag>
          </Text>
        </Box>
        <Flex flexWrap='wrap' gap='xs'>
          {values.auto_accept_rosters?.map((roster: IRoster) => (
            <Tag mr='xs' key={roster.id} type='primary' size='small'>
              {roster.name}
            </Tag>
          ))}
        </Flex>
      </SectionContainer>
    )
  }

  if (AutoAccept) {
    return (
      <SectionContainer>
        <Flex mb='sm' justifyContent='space-between'>
          <Text variant='h6'>Acceptance Criteria</Text>
          <FontAwesomeIcon
            icon={faPen}
            size='lg'
            style={{
              marginLeft: '8px',
              cursor: 'pointer',
              color: Colors.primary_500,
            }}
            onClick={handleNavigateToEditShift}
          />
        </Flex>
        <Box mb='sm'>
          <Text fontSize='large'>Verified Upshifters</Text>
        </Box>
        <Box mb='sm'>
          <Flex mb='xs' alignItems='center'>
            <FontAwesomeIcon
              icon={faCheck}
              color='#43b94a'
              size='lg'
              style={{ marginRight: '8px' }}
            />
            <Box>
              <Text>
                Access our full pool of qualified and verified Uphshifters who meet your shift
                requirements.
              </Text>
            </Box>
          </Flex>
        </Box>
      </SectionContainer>
    )
  }

  return (
    <SectionContainer>
      <Flex mb='sm' justifyContent='space-between'>
        <Text variant='h6'>Acceptance Criteria</Text>
        <FontAwesomeIcon
          icon={faPen}
          size='lg'
          style={{
            marginLeft: '8px',
            cursor: 'pointer',
            color: Colors.primary_500,
          }}
          onClick={handleNavigateToEditShift}
        />
      </Flex>
      <Box mb='sm'>
        <Text fontSize='large'>Personally approved Upshifters</Text>
      </Box>
      <Box mb='sm'>
        <Flex mb='xs' alignItems='center'>
          <FontAwesomeIcon
            icon={faCheck}
            color='#43b94a'
            size='lg'
            style={{ marginRight: '8px' }}
          />
          <Box>
            <Text>
              Review and approve each Upshifter’s application before they can claim the shift.{' '}
            </Text>
          </Box>
        </Flex>
      </Box>
    </SectionContainer>
  )
})
